<template>
  <img v-if="validateName" :src="iconComponent" />
</template>

<script>
import { mapCacheActions } from 'vuex-cache';
import { mapState } from 'vuex';

export default {
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    }
  },

  data: () => ({}),

  computed: {
    ...mapState(['loading']),
    ...mapState('phone_flags', ['icons']),
    iconComponent() {
      return this.icons[this.name];
    },
    validateName() {
      return Object.prototype.hasOwnProperty.call(this.icons, this.name);
    }
  },

  mounted() {
    this.getIcons();
  },

  methods: {
    ...mapCacheActions('phone_flags', ['getIcons'])
  }
};
</script>
